import styled from "@emotion/styled"

export const StoreInfoStyled = styled.div`

`